import { Carousel, Col, Container, Row } from "react-bootstrap";
import { chunk } from "lodash";
import classes from "./styles.module.scss";
import clsx from "classnames";
import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import { Title, Description } from "@/ui";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@react-hook/media-query";

const BlockQuoteCards = ({ sectionId, className, items, visibleCount }) => {
  return (
    <Row id={sectionId} className={clsx(className, { "h-100 px-4": visibleCount > 1 })}>
      {items.map(({ quote, author, img }, k) => (
        <Col key={k}>
          <div className={clsx(classes.card, "h-100 d-flex align-items-start")}>
            {img?.url && (
              <div className={classes.imageWrapper}>
                <img src={img.url} alt={author?.name || "Author"} className={classes.image} />
              </div>
            )}
            <div className={classes.quoteIcon}>“</div>
            <div className={classes.content}>
              <div className={classes.quote} dangerouslySetInnerHTML={{ __html: quote }} />
              <cite className={classes.author}>
                {author?.name ? (
                  <>
                    {author?.name && <strong>{author.name}</strong>}
                    {author?.position && `, ${author.position}`}
                    {author?.company && `, ${author.company}`}{" "}
                  </>
                ) : (
                  <>
                    {author?.position && ` ${author.position}`}
                    {author?.company && `, ${author.company}`}
                  </>
                )}
              </cite>
            </div>
            <div className={classes.quoteIcon2}>“</div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default function BlockQuote({
  className,
  bgColor,
  title,
  titleColor,
  description,
  items,
  carousel = false,
  visibleCount: desktopVisibleCount = 3,
  img,
}) {
  const [visibleCount, setVisibleCount] = useState(2);
  const xl = useMediaQuery("only screen and (min-width: 1200px)");
  const lg = useMediaQuery("only screen and (min-width: 992px)");
  const md = useMediaQuery("only screen and (min-width: 768px)");

  useEffect(() => {
    setVisibleCount(xl ? desktopVisibleCount : lg ? 3 : md ? 2 : 1);
  }, [xl, lg, md, desktopVisibleCount]);

  if (items.length === 0) return null;

  const quoteContent = carousel ? (
    <Carousel
      className={clsx(classes.blockquotes__carousel)}
      controls={true}
      indicators={false}
      prevIcon={items.length > visibleCount && <ChevronLeft width="14" height="25" />}
      nextIcon={items.length > visibleCount && <ChevronRight width="14" height="25" />}
    >
      {chunk(items, parseInt(`${visibleCount}`)).map((items, k) => (
        <Carousel.Item key={k}>
          <BlockQuoteCards items={items} visibleCount={visibleCount} />
        </Carousel.Item>
      ))}
    </Carousel>
  ) : (
    <div className="px-5">
      {chunk(items, visibleCount).map((items, k) => (
        <BlockQuoteCards key={k} items={items} visibleCount={visibleCount} />
      ))}
    </div>
  );

  return (
    <div className={clsx(className, bgColor, classes.blockquotes)}>
      <Container>
        <Title className={titleColor} title={title} />
        <Description description={description} />
        {img?.url ? (
          <Row className="align-items-center">
            <Col md={5} className={classes.imageCol}>
              <div className={classes.imageContainer}>
                <img src={img.url} alt="Quote Visual" className={classes.image} />
              </div>
            </Col>
            <Col md={7}>{quoteContent}</Col>
          </Row>
        ) : (
          quoteContent
        )}
      </Container>
    </div>
  );
}
